import { CssBaseline, ThemeProvider as MUIThemeProvider, StyledEngineProvider, createTheme } from '@mui/material';
import { useMemo } from 'react';

import componentsOverride from './overrides';
import palette from './palette';
import typography from './typography';

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  const themeOptions = useMemo(
    () => ({
      palette,
      shape: { borderRadius: 8 },
      typography,
    }),
    [],
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
